module.exports = __webpack_public_path__ + "img/Article-2021-03-07-2100-dashboard.ce237b2f.gif";